var scope_0 = require('/home/runner/work/wingbot/wingbot/documentation/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1a18f9279eab980c89ba8543f71bc07b.js').default;

var scope_1 = require('/home/runner/work/wingbot/wingbot/documentation/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

export default Object.assign({}, scope_0, scope_1);